module.exports = __webpack_public_path__ + "static/pam-local-9964d71f83dbf1f65c7e26957123a7b2.jpg";